import { Download, FileText, X } from "lucide-react";
import { shortLabel } from "./dates";

export default function SavedPlansCard({ saved, onDownload, onDelete }) {
  return (
    <div className="hq-glass rounded-2xl p-4">
      <p className="text-sm font-medium text-slate-200 mb-3">Saved plans</p>
      {saved.length === 0 ? <p className="text-sm text-muted-foreground">No saved lesson plans yet.</p> : (
        <div className="space-y-2" data-testid="lp-saved-plans">
          {saved.map((p) => (
            <div key={p.id} data-testid={`lp-saved-${p.id}`} className="flex items-center justify-between gap-3 rounded-lg border border-white/10 bg-white/[0.02] px-3 py-2 flex-wrap">
              <div className="flex items-center gap-2 min-w-0">
                <FileText className="w-4 h-4 text-[#22D3EE] shrink-0" />
                <div className="min-w-0">
                  <p className="text-sm text-slate-200 truncate">{p.name}</p>
                  <p className="text-[11px] text-muted-foreground">{(p.plans || []).length} day{(p.plans || []).length !== 1 ? "s" : ""}{p.template_id ? " · your template" : " · built-in layout"}</p>
                </div>
              </div>
              <div className="flex items-center gap-1.5 flex-wrap">
                {(p.plans || []).map((d, di) => (
                  <button key={di} data-testid={`lp-dl-${p.id}-${di}`} onClick={() => onDownload(p.id, di)} className="text-xs px-2 h-8 rounded bg-slate-700 text-slate-100 hover:bg-slate-600 inline-flex items-center gap-1"><Download className="w-3.5 h-3.5" /> {d.date ? shortLabel(d.date) : `Day ${di + 1}`}</button>
                ))}
                {(p.plans || []).length > 1 && <button data-testid={`lp-dl-week-${p.id}`} onClick={() => onDownload(p.id, null)} className="text-xs px-2 h-8 rounded bg-[#22D3EE] text-[#04121f] hover:bg-[#22D3EE]/90 inline-flex items-center gap-1"><Download className="w-3.5 h-3.5" /> Whole week</button>}
                <button data-testid={`lp-delete-${p.id}`} onClick={() => onDelete(p.id)} className="text-xs text-[#E11D48] px-2 h-8 inline-flex items-center gap-1 hover:underline"><X className="w-3.5 h-3.5" /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
